/* global Ajax, Site */

jQuery(document).ready(($) => {
	/**
	 * Get species cards via AJAX
	 * @param {number} id Post ID
	 * @param {number} page Current page
	 * @param {number} postsPerPage Posts per page
	 * @param {HTMLElement} targetElement Target element
	 * @param {Array} taxQuery Tax query
	 * @param {string} term Term
	 */
	function getSpeciesCards(id, page, postsPerPage, targetElement, taxQuery = [], term = '') {
		targetElement.prepend('<div class="spinner"></div>');

		$.ajax({
			url: Ajax.url,
			data: {
				action: 'get_lajikortit',
				nonce: Ajax.nonce,
				page,
				lang: Site.lang,
				postsPerPage,
				taxQuery,
				term,
				id,
			},
			type: 'GET',
		})
			.done((response) => {
				targetElement.html(response.data);
			})
			.fail((error) => {
				console.error(error);
			});
	}

	/**
	 * Species cards pagination handler
	 * @param {HTMLElement} paginationElement Pagination element
	 * @param {HTMLElement} targetElement Target element
	 * @param {HTMLElement} scrollTarget Scroll target
	 * @param {number} page Current page
	 */
	function paginationHandler(paginationElement, targetElement, scrollTarget, page) {
		// Scroll to top
		$('html, body').animate(
			{
				scrollTop: $(scrollTarget).offset().top - 100,
			},
			200,
		);

		const postsPerPage = paginationElement.attr('data-posts-per-page');
		const taxQuery = paginationElement.attr('data-tax-query');
		const term = paginationElement.attr('data-term');
		const id = paginationElement.attr('data-post-id');

		getSpeciesCards(id, page, postsPerPage, targetElement, taxQuery, term);
	}

	$(document).on('click', 'section.species-cards-block .ajax-pagination a', function (event) {
		event.preventDefault();

		if ($(this).attr('tabindex') === '-1') {
			return;
		}

		const paginationElement = $(this).closest('.ajax-pagination');
		const targetElement = $('section.species-cards-block .grid');
		const scrollTarget = $('section.species-cards-block');
		const page = $(this).attr('data-page');

		paginationHandler(paginationElement, targetElement, scrollTarget, page);
	});

	$(document).on('click', '.related-species .ajax-pagination a', function (event) {
		event.preventDefault();

		if ($(this).attr('tabindex') === '-1') {
			return;
		}

		const paginationElement = $(this).closest('.ajax-pagination');
		const targetElement = $('.related-species .related-species-grid');
		const scrollTarget = $('.related-species');
		const page = $(this).attr('data-page');

		paginationHandler(paginationElement, targetElement, scrollTarget, page);
	});
});
